// extracted by mini-css-extract-plugin
module.exports = {"body":"BindCallToRequestModal_body__1dsCJ"};